module.exports = __webpack_public_path__ + "img/aa.525e0655.svg";